import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M23 104a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="M107 68a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M11 102c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#0597A3"
      d="m93.82 62.06-10-30A2.98 2.98 0 0 0 81 30.03H35c-1.28 0-2.42.82-2.82 2.03l-10 30c-.42 1.25.04 2.62 1.12 3.38l32.53 22.77c.51.36 1.11.54 1.71.54s1.17-.17 1.67-.52l33.47-22.77c1.1-.75 1.57-2.14 1.15-3.4z"
    />
    <path
      fill="#D8FFFF"
      d="M69.8 27H46.2a4.2 4.2 0 0 0-4.2 4.2v9.6a4.2 4.2 0 0 0 4.2 4.2h23.6a4.2 4.2 0 0 0 4.2-4.2v-9.6a4.2 4.2 0 0 0-4.2-4.2"
    />
    <path
      fill="#0597A3"
      d="M69.8 47H46.19c-3.42 0-6.2-2.78-6.2-6.2v-9.61c0-3.42 2.78-6.2 6.2-6.2H69.8c3.42 0 6.2 2.78 6.2 6.2v9.61c0 3.42-2.78 6.2-6.2 6.2M46.19 29a2.2 2.2 0 0 0-2.2 2.2v9.61c0 1.21.98 2.2 2.2 2.2H69.8a2.2 2.2 0 0 0 2.2-2.2V31.2a2.2 2.2 0 0 0-2.2-2.2z"
    />
    <path
      fill="#D8FFFF"
      d="M75.49 39H40.51A4.51 4.51 0 0 0 36 43.51v8.98A4.51 4.51 0 0 0 40.51 57h34.98A4.51 4.51 0 0 0 80 52.49v-8.98A4.51 4.51 0 0 0 75.49 39"
    />
    <path
      fill="#0597A3"
      d="M75.49 59H40.52c-3.59 0-6.51-2.92-6.51-6.51v-8.97c0-3.59 2.92-6.51 6.51-6.51h34.97c3.59 0 6.51 2.92 6.51 6.51v8.97c0 3.59-2.92 6.51-6.51 6.51M40.52 41c-1.39 0-2.51 1.13-2.51 2.51v8.97c0 1.39 1.13 2.51 2.51 2.51h34.97c1.39 0 2.51-1.13 2.51-2.51v-8.97c0-1.39-1.13-2.51-2.51-2.51z"
    />
    <path
      fill="#D8FFFF"
      d="M80.01 53H35.99A4.99 4.99 0 0 0 31 57.99v16.02A4.99 4.99 0 0 0 35.99 79h44.02A4.99 4.99 0 0 0 85 74.01V57.99A4.99 4.99 0 0 0 80.01 53"
    />
    <path
      fill="#0597A3"
      d="M80.01 81H36c-3.86 0-6.99-3.14-6.99-6.99V58c0-3.86 3.14-6.99 6.99-6.99h44.01c3.86 0 6.99 3.14 6.99 6.99v16.01c0 3.86-3.14 6.99-6.99 6.99M36 55c-1.65 0-2.99 1.34-2.99 2.99V74c0 1.65 1.34 2.99 2.99 2.99h44.01c1.65 0 2.99-1.34 2.99-2.99V57.99c0-1.65-1.34-2.99-2.99-2.99z"
    />
    <path
      fill="#00D8D8"
      d="M91 60H77c-4.37 0-6.58 3.19-8.36 5.76C66.76 68.47 65.58 70 63 70H53c-2.59 0-3.78-1.53-5.65-4.24C45.58 63.19 43.37 60 39 60H25c-1.66 0-3 1.34-3 3v26c0 1.66 1.34 3 3 3h66c1.66 0 3-1.34 3-3V63c0-1.66-1.34-3-3-3"
    />
    <path
      fill="#001A43"
      d="M65 83.25H51c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h14c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M95 53c10.49 0 19-8.51 19-19s-8.51-19-19-19-19 8.51-19 19 8.51 19 19 19"
    />
    <path
      fill="#00D8D8"
      d="M103.25 37.75c0-3.65-2.65-6-6.75-6h-3c-2.25 0-2.25-.98-2.25-1.5s0-1.5 2.25-1.5h6.5c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25h-2.75V24c0-1.24-1.01-2.25-2.25-2.25s-2.25 1.01-2.25 2.25v.28c-3.67.27-6 2.56-6 5.97 0 3.65 2.65 6 6.75 6h3c2.25 0 2.25.98 2.25 1.5s0 1.5-2.25 1.5H90c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25h2.75V44c0 1.24 1.01 2.25 2.25 2.25s2.25-1.01 2.25-2.25v-.28c3.67-.27 6-2.56 6-5.97M88.63 103.87h-5.57V98.3c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M25.06 29.43l-3.94-3.94 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0L19 23.37l-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.59.58 1.54.59 2.12 0L19 27.61l3.94 3.94c.59.59 1.54.59 2.12 0s.59-1.54 0-2.12"
    />
  </svg>
);
const SvgEnrichedIconCostInboxInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCostInboxInverted);
export default Memo;
